import { Input, InputProps } from "@/components/Input";
import { CallbackReturnType } from "@/types";
import { BuilderProps } from "@/types/builder/BuilderProps";
import { Blocks, BuilderBlock } from "@builder.io/sdk-react";
import { FC, useEffect, useRef } from "react";

type CheckboxInputBlockProps = {
  type: "checkbox";
  onChange?: (value: boolean, elem: HTMLElement | null) => CallbackReturnType;
  onChangeState?: (event: unknown) => CallbackReturnType;
  onInitialize?: (elem: HTMLElement | null) => () => void;
  label?: BuilderBlock[];
} & InputProps &
  BuilderProps;

export const CheckboxInputBlock: FC<CheckboxInputBlockProps> = ({
  children: _,
  builderContext,
  builderBlock,
  builderComponents,
  builderLinkComponent,
  label,
  onChangeState,
  onInitialize,
  ...props
}) => {
  const checkboxRef = useRef<HTMLElement | null>(null);
  useEffect(() => {
    if (onChangeState) {
      const elem = checkboxRef.current;
      elem?.addEventListener("changeState", onChangeState);

      return () => {
        elem?.removeEventListener("changeState", onChangeState);
      };
    }
  }, [onChangeState]);

  useEffect(() => {
    if (onInitialize) {
      onInitialize?.(checkboxRef.current);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onValueChange = async (value: boolean) => {
    if (props.onChange) {
      await props.onChange(value, checkboxRef.current);
    }
  };

  return (
    <Input
      {...props}
      ref={checkboxRef}
      onChange={onValueChange}
      checked={props.value === "true"}
      type="checkbox"
      label={
        <Blocks
          parent={builderBlock?.id}
          registeredComponents={builderComponents}
          linkComponent={builderLinkComponent}
          context={builderContext}
          path={`label`}
          blocks={label}
        />
      }
    />
  );
};
